export class ColorOption {
  name: string;
  value: string;
}
